import React from 'react';
import classNames from 'classnames';
import styles from './PlaceholderBar.scss';

export type PlaceholderBarProps = {
  width?: string | number;
  height?: string | number;
  colour?: 'nobel' | 'very-light-grey';
  marginBottom?: string;
  marginRight?: string | number;
  animated?: boolean;
  className?: string;
};

export class PlaceholderBar extends React.PureComponent<PlaceholderBarProps> {
  static defaultProps = {
    width: '100%',
    colour: 'very-light-grey',
    height: '10px',
    marginBottom: '15px',
    className: '',
  };

  render() {
    const {
      width,
      height,
      colour,
      marginBottom,
      animated,
      className,
      marginRight,
    } = this.props;

    return (
      <span
        data-qa="placeholder-bar"
        className={classNames(
          styles.placeholderbar,
          `jg-background--${colour}`,
          { [styles.animated]: animated },
          className,
        )}
        style={{ height, width, marginBottom, marginRight }}
        aria-hidden
      />
    );
  }
}

export default PlaceholderBar;
